import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import globalStore from '@/store/global';

const Contract = observer<{ huhandleConsent: () => void }>(
  ({ huhandleConsent }) => {
    const cloudConfig = useMemo(
      () => globalStore.cloudConfig?.assistantAiimagevideoCreatorprotocol,
      [globalStore.cloudConfig?.assistantAiimagevideoCreatorprotocol]
    );
    return (
      <div className="work-publish-confirm flex flex-col w-620px h-[calc(100vh-160px)] max-h-[740px] p-24px text-[#1D2129]">
        <div className="text-center text-18px font-bold mt-10px">
          {cloudConfig?.protocol_title}
        </div>
        <div className="text-12px mt-30px flex overflow-y-scroll nw-scrollbar">
          <div
            dangerouslySetInnerHTML={{ __html: cloudConfig?.protocol_text }}
          />
        </div>
        <div className="flex gap-12px mt-12px justify-end">
          <button
            className={`aigc-submit-btn w-140px flex items-center justify-center flex-shrink-0 leading-12px h-44px bg-[#000] rounded-12px text-[#fff] text-14px`}
            style={{
              background: 'linear-gradient(to right, #484E5F 0%, #242425 50%, #484E5F 100%)',
            }}
            onClick={huhandleConsent}
          >
            {cloudConfig?.protocol_main_btn}
          </button>
        </div>
      </div>
    );
  }
);
export default Contract;
